import actions from "./financial-tools-actions";
const toolsStore = {
  namespaced: true,
  actions
};
export default toolsStore;